// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"976aae30","475":"8f869eb6","480":"8d735634","515":"5cb11047","631":"3ecfc7cf","652":"d59ff9c7"}[chunkId] + ".chunk.css";
};